// @flow

// Libs

// Effect Managers
import { call, fork } from 'redux-saga/effects'

// Controller
import controller from 'hfty-ctrl-supplies'


// Sagas

export default function *main (): Generator<*, *, *> {
  yield call(controller.start)
  yield fork(controller.watch)
  yield call(controller.read)
}
